var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"lazy-validation":""}},[_c('Input',{attrs:{"data":{
      text:
        this.user.car.maketext !== undefined
          ? this.text.registrationplate + ': ' + this.user.car.maketext + ' ' + this.user.car.modeltext + ''
          : this.text.registrationplate,
      name: 'registrationplate',
      onkeyup: false,
      onblur: true,
      value: this.user.registrationplate,
      rules: this.user.errors.registration !== '' ? this.registrationplateErrorRules : this.registrationplateRules
    }},on:{"childToParent":_vm.inputPlatesChange}}),_c('CustomVehicleSelectors'),_c('Number',{ref:"numberInput",attrs:{"data":{
      text: this.text.kilometers,
      name: 'kilometers',
      onkeyup: true,
      onblur: false,
      value: this.user.kilometers,
      router: 'Service',
      rules: this.kilometersRules
    }},on:{"childToParent":_vm.inputKmChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }